// Central initializer that safely starts all Swipers present on the page
// Each initializer will no-op if its target element is not found
import { initSlider } from './slider';
import { initSwiperCarousel } from './swiper-carousel';
import { initSwiperTabsGallery } from './swiper-tabs-gallery';
import { initSwiperAudio } from './swiper-audio';
import { initSwiperVideo } from './swiper-video';

export function initAllSwipers() {
    // Run after DOM is ready to ensure elements exist
    const start = () => {
        initSlider();
        initSwiperCarousel();
        initSwiperTabsGallery();
        initSwiperAudio();
        initSwiperVideo();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }
}

// Auto-run in module context for convenience when directly imported
initAllSwipers();
